import React from 'react'
import DashboardHeader from '../../components/Shop/Layout/DashboardHeader'
import DashboardSideBar from '../../components/Shop/Layout/DashboardSideBar'
import AllCoupons from "../../components/Shop/AllCoupons";

const ShopAllCoupouns = () => {
  return (
    <div className="dashboard-page-wrapper">
      <DashboardHeader />
      <div className="dashboard-flex-wrapper">
        <div className="w-[80px] 800px:w-[330px] dashboard-sidebar">
          <DashboardSideBar active={9} />
        </div>
        <div className="dashboard-main-content flex-1">
          <AllCoupons />
        </div>
      </div>
    </div>
  )
}

export default ShopAllCoupouns